import { render, staticRenderFns } from "./eBoekhouden.vue?vue&type=template&id=5aca1e1c&"
import script from "./eBoekhouden.vue?vue&type=script&lang=js&"
export * from "./eBoekhouden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports